/* eslint-disable no-unused-vars */
export enum TranslationStyle {
    SWORN = 'sworn',
    FREE = 'free',
    BOTH = 'both',
}

export const taskTypes = [TranslationStyle.SWORN, TranslationStyle.FREE, TranslationStyle.BOTH];
